<template>
	<v-app-bar color="primary" dark v-if="this.$store.state.user_data" app>
		<!--Back y nombre view-->
		<div v-show="!this.$store.getters.isMenuView" id="titleNav">
			<v-btn icon @click="$router.back()"> <v-icon>mdi-arrow-left</v-icon></v-btn>
			<v-toolbar-title>{{ this.$store.state.nombreVista }}</v-toolbar-title>
		</div>
		<!-- Logo y brand-->
		<div v-show="this.$store.getters.isMenuView" class="cont-lb">
			<v-icon color="white" size="40">mdi-school</v-icon>
			<div class="cont-brand">
				<span class="lb-centro">Ingeniería<b>+</b> </span>
				<span class="lb-me">Miguel De Olim</span>
			</div>
		</div>

		<v-spacer></v-spacer>

		<v-toolbar-items>
			<v-menu left bottom offset-y>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>

				<v-list>
					<v-list-item :to="{ name: 'Informacion' }">
						<v-list-item-title>Información</v-list-item-title>
					</v-list-item>
					<v-list-item :to="{ name: 'Configuracion' }">
						<v-list-item-title>Configuración</v-list-item-title>
					</v-list-item>
					<v-list-item @click="cerrarSesionUsuario">
						<v-list-item-title>Cerrar sesión</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-toolbar-items>

		<template v-slot:extension v-if="this.$store.state.need_tabs">
			<portal-target name="tabs_nav" id="portal"> </portal-target>
		</template>
	</v-app-bar>
</template>

<script>
import { mapActions } from "vuex";

export default {
	methods: {
		...mapActions(["cerrarSesionUsuario"])
	}
};
</script>

<style>
#portal {
	width: 100%;
}

div.cont-brand {
	display: inline-grid;
	padding-left: 5px;
}

span.lb-centro {
	border-bottom: 1px solid;
	padding: 0 2px;
}

span.lb-me {
	font-weight: lighter;
	font-size: 0.8em;
}

.cont-lb {
	display: flex;
	align-items: center;
}

div#titleNav {
	display: contents;
}
</style>
